import qs from 'qs'
import SuperagentApi from '../assets/utils/superagent'

const token = Wiz.AuthHooks.GetToken()
const headers = {
  Authorization: `Bearer ${token}`,
}
const superagentApi = new SuperagentApi({
  baseUrl: window.ApiBase || 'http://pr.code.wiz.top:1052',
})
export default class DiyService {
  // 获取列表数据
  static async getTableData(payload) {
    const [err, res] = await superagentApi.post('/api/FormEngine/getTableData', {
      data: payload,
      headers,
    })
    return [err, res]
  }
  // 更新表单数据
  static async updateFormData(payload) {
    const [err, res] = await superagentApi.post('/api/FormEngine/uptFormData', {
      data: payload,
      headers,
    })
    return [err, res]
  }
  // 获取节点审批人
  static async getNodeConfirmUsers(payload) {
    const [err, res] = await superagentApi.post('/api/WorkFlow/GetNodeConfirmUsers', {
      data: payload,
      headers: { ...headers, 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    return [err, res]
  }
  // 获取下一节点审批人
  static async getNextNodeConfirmUsers(payload) {
    const [err, res] = await superagentApi.post('/api/WorkFlow/getNextNodeConfirmUsers', {
      data: payload,
      headers: { ...headers, 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    return [err, res]
  }
  // 获取审批节点数据
  static async getFlowHistoryList(payload) {
    const [err, res] = await superagentApi.post('/api/WorkFlow/getWFHistory', {
      data: payload,
      headers: { ...headers, 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    return [err, res]
  }
}
